export default __webpack_public_path__ + "static/media/gallery-wip-clamp-card_01.b6b2c611.jpg";